"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MONTHLY_SUBSCRIPTION_PLAN_SERVICE_CONSTANTS = void 0;
exports.MONTHLY_SUBSCRIPTION_PLAN_SERVICE_CONSTANTS = {
    deploymentSubsets: {
        main: 'main',
        canary: 'canary',
    }
};
//# sourceMappingURL=MonthlySubscriptionPlanServiceConstants.js.map